exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titles-numericos {\n    font-weight: bold;\n    font-size: 1.2em;\n}\n\n\n\n.ui-button.ui-widget.ui-state-default.ui-corner-all.ui-button-icon-only {\n    border-radius: 15px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/area-restrita/financeiro/declaracao-rendimento-emp-fin/declaracao-rendimento-emp-fin.component.css
// module id = ../../../../../src/app/area-restrita/financeiro/declaracao-rendimento-emp-fin/declaracao-rendimento-emp-fin.component.css
// module chunks = main